import { Container } from 'ui/components/4-habitats/Container/Container';
import { PreviewCardList } from '../PreviewCardList/PreviewCardList';
import { PreviewCardProps } from 'ui/components/2-molecules/Card/PreviewCard/PreviewCard';
import ColorOptions from 'helpers/types';
import classNames from 'classnames';
import styles from './AdaptableList.module.scss';
import { Heading } from 'ui/components/1-atoms/Heading/Heading';
import { TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { RichText } from 'ui/components/1-atoms/RichText/RichText';

export interface AdaptableListProps {
	adaptableListitem: PreviewCardProps[];
	buttonText: string;
	title?: string;
	description?: string;
	bgColor?: ColorOptions;
}

export const AdaptableList: React.FC<AdaptableListProps> = ({ adaptableListitem, buttonText, bgColor, title, description }) => {
	return (
		<div className={classNames(styles.AdaptableList, styles[`u-color___${bgColor}`])}>
			<Container width="Standard">
				{title && (
					<Heading headingLevel="h2" style="xl" className={styles.AdaptableList_heading}>
						{title}
					</Heading>
				)}
				<TopLevelGrid nogutter wrap>
					<TopLevelGridCell desktopWidth="10col" mobileWidth="100">
						{description && <RichText content={description} className={styles.AdaptableList_description} />}
					</TopLevelGridCell>
				</TopLevelGrid>
				{adaptableListitem && (
					<PreviewCardList
						items={adaptableListitem.map((item) => {
							return {
								...item,
								headline: item.headline,
								text: item.text,
								image: { ...item.image, altText: item.image.altText },
								link: item.link,
								tags: { first: item.tags.first, second: item.tags.second },
								video: {
									...item.video,
									mediaURL: item.video?.mediaURL,
									posterURL: item.image?.url,
								},
							};
						})}
						buttonText={buttonText}
						marginBottom
					/>
				)}
			</Container>
		</div>
	);
};
